import { useRef, useEffect, useCallback } from 'react';
import { View, Text, TextInput, Pressable, StyleSheet } from 'react-native';
import { useAppStore } from '../store/appStore';
import { useAppNavigate } from '../hooks/useRouteParams';
import { regexMatch } from '../services/utils';
import { Fonts, MdiIcons } from '../styles/fonts';

const DRAWER_WIDTH = 280;
const MARGIN = 10;

export default function SearchInput() {
  const cardInputValue = useAppStore((s) => s.cardInputValue);
  const setCardInput = useAppStore((s) => s.setCardInput);
  const closeDrawers = useAppStore((s) => s.closeDrawers);
  const chapters = useAppStore((s) => s.chapters);
  const navigate = useAppNavigate();
  const inputRef = useRef<any>(null);

  useEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 50);
  }, []);

  const hideSearch = useCallback(() => setCardInput('', ''), [setCardInput]);

  const handleSubmit = useCallback(() => {
    if (!regexMatch(cardInputValue)) return;
    const jumpUrl = '/' + cardInputValue.replace(':', '/').replace(/ /g, '');
    hideSearch();
    closeDrawers();
    if (jumpUrl === '/0') {
      const randomCh = Math.floor(Math.random() * 114) + 1;
      const maxVs = chapters[randomCh - 1]?.num_of_verses || 1;
      navigate(`/${randomCh}/${Math.floor(Math.random() * maxVs) + 1}`);
    } else {
      navigate(jumpUrl);
    }
  }, [cardInputValue, hideSearch, closeDrawers, navigate, chapters]);

  return (
    <View style={styles.bar}>
      <Text style={styles.searchIcon}>{MdiIcons.search}</Text>
      <TextInput
        ref={inputRef}
        style={styles.input}
        value={cardInputValue}
        onChangeText={(text) => setCardInput('search', text)}
        onSubmitEditing={handleSubmit}
        placeholder='type "kahf" or 18:1-7 and press enter'
        placeholderTextColor="#aaa"
        returnKeyType="search"
      />
      <Pressable onPress={hideSearch} style={styles.closeBtn}>
        <Text style={styles.closeIcon}>{MdiIcons.close}</Text>
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  bar: {
    position: 'absolute',
    top: 4,
    left: MARGIN,
    width: DRAWER_WIDTH - MARGIN * 2,
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#ffffff',
    borderRadius: 4,
    paddingHorizontal: 8,
    height: 42,
    elevation: 5,
    zIndex: 1300,
    // @ts-expect-error web shadow
    boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
  },
  searchIcon: {
    fontFamily: Fonts.MDI,
    fontSize: 20,
    color: '#555',
    marginRight: 4,
  },
  input: {
    flex: 1,
    fontSize: 14,
    height: 42,
    color: '#333',
    // @ts-expect-error web outline
    outlineStyle: 'none',
  },
  closeBtn: {
    height: 40,
    marginLeft: 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
  closeIcon: {
    fontFamily: Fonts.MDI,
    fontSize: 20,
    color: '#555',
  },
});
